import T from 'prop-types';
import { avatarPropType } from '../../customPropTypes';

export default Schema => {
  if (Schema === undefined) {
    throw new Error('Cannot define proptype of Schema (undefined)');
  }
  return T.shape({
    pending: T.boolean,
    error: T.oneOfType([T.string, T.instanceOf(Error)]),
    data: T.instanceOf('Schema' in Schema ? Schema.Schema : Schema),
  });
};

export const episodePropType = T.shape({
  data: T.shape({
    id: T.string,
    channel: T.string,
    show: T.string,
    created: T.string,
    modified: T.string,
    publishedOn: T.string,
    publishDate: T.string,
    exclusive: T.bool,
    language: T.string,
    image: T.oneOfType([T.string, avatarPropType]),
    permalinks: T.arrayOf(T.string),
    tags: T.array,
    keywords: T.array,
    categories: T.array,
    name: T.string,
    description: T.string,
    rating: T.string,
    conditions: T.array,
    rssAuthor: T.string,
    rssSubtitle: T.string,
    rssSummary: T.string,
    rssLink: T.string,
    mediaURL: T.string,
    contentLength: T.number,
    episodeType: T.string,
    seasonNumber: T.number,
    episodeNumber: T.number,
  }),
  error: T.object,
  pending: T.bool,
});

export const showPropType = T.shape({
  data: T.shape({
    id: T.string,
    created: T.string,
    modified: T.string,
    name: T.string,
    description: T.string,
    network: T.object,
    rating: T.string,
    image: T.oneOfType([T.string, avatarPropType]),
    homepage: T.string,
    language: T.string,
    popularity: T.number,
    midrollThreshold: T.number,
    permalinks: T.arrayOf(T.string),
    categories: T.array,
    keywords: T.array,
    tags: T.array,
    integrations: T.array,
    exclusive: T.boolean,
    featured: T.boolean,
    rssSubtitle: T.string,
    rssSummary: T.string,
    rssAuthor: T.string,
    rssEmail: T.string,
    showType: T.string,
    flags: T.array,
    products: T.array,
  }),
  error: T.object,
  pending: T.boolean,
});

export const mediaFilePropType = T.shape({
  data: T.shape({
    id: T.string,
    created: T.string,
    modified: T.string,
    bitrate: T.number,
    duration: T.number,
    channelCount: T.number,
    contentLength: T.number,
    episodeId: T.string,
    encoding: T.string,
    mediaUrl: T.string,
    offsetToAudio: T.number,
    peakFileUrl: T.string,
    samplingRate: T.number,
    sourceMediaUrl: T.string,
    s3MediaUrl: T.string,
    s3PeakFileUrl: T.string,
    showId: T.string,
    silenceDetected: T.array,
  }),
  error: T.object,
  pending: T.boolean,
});
